export default __webpack_public_path__ + "static/media/CrayolaLogo.87f4ad32.png";